import React, { useState, useEffect } from 'react';
import { ArrowLeft, User, Phone, Mail, Scale, Activity, Pill, Home, MapPin, Package, FileText, Search, Trash2, Plus, Minus, Loader, Check, ChevronDown } from 'lucide-react';
import ProductSelectionModal from '../components/ProductSelectionModal';
import { ordersApi, leadsApi } from '../services/api';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { message } from 'antd';
import { useTheme } from '../context/ThemeContext';

function EditOrder() {
  const { currentTheme } = useTheme();
  const isDark = currentTheme.textColor === '#FFFFFF';
  const [showSuccess, setShowSuccess] = useState(false);
  const [showProductModal, setShowProductModal] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingPincode, setLoadingPincode] = useState(false);
  const [postOfficeOptions, setPostOfficeOptions] = useState([]);
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  // ─── formData initial state ───────────────────────────────────────────────────
// useState mein city: '' add karo
const [formData, setFormData] = useState({
  // Customer
  name: '',
  contactNumber: '',
  alternateNumber: '',
  email: '',
  gender: 'MALE',
  age: '',
  height: '',
  weight: '',
  actualProblem: '',
  existingTreatment: '',
  maritalStatus: '',
  // Address
  addressType: 'City',
  latitude: '',
  longitude: '',
  houseNumber: '',
  streetName: '',
  colonyName: '',
  landmark: '',
  areaPinCode: '',
  postOffice: '',
  city: '',          // ✅ BUG FIX: city field add kiya
  district: '',
  state: '',
  // Order
  orderType: '',
  remarks: '',
  shippingMethod: '',
  paymentType: '',
  paymentMode: '',
  prepaidAmount: 0,
  discount: 0,
  shippingCharges: 0,
  leadId: null,
});

  const maritalStatuses = ['Married', 'Single'];

  const handleClose = () => {

    navigate(-1);
  };

  // ─── Load order data ─────────────────────────────────────────────────────────
  useEffect(() => {
    loadOrderData();
  }, []);

  // ✅ SAHI - calculateSubtotal use karo, calculateGrandTotal nahi
useEffect(() => {
  const subtotal = calculateSubtotal();
  const discount = parseFloat(formData.discount) || 0;
  const shipping = parseFloat(formData.shippingCharges) || 0;
  const trueTotal = Math.max(0, subtotal - discount + shipping);

  if (formData.paymentType === 'FULL_PAYMENT') {
    setFormData(prev => ({ ...prev, prepaidAmount: trueTotal }));
  } else if (formData.paymentType === 'COD') {
    setFormData(prev => ({ ...prev, prepaidAmount: 0 }));
  }
}, [formData.paymentType, selectedProducts, formData.discount, formData.shippingCharges]);

  // ─── loadOrderData ────────────────────────────────────────────────────────────
const loadOrderData = async () => {
  try {
    setLoading(true);
    const orderDetails = await ordersApi.getOrderDetails(id);
    const orderData = orderDetails.order;
    const lead = orderDetails.lead;
    console.log('orderDetails', orderDetails);

    setFormData({
      leadId: lead?.id || null,
      // Customer
      name: lead?.customerName || '',
      contactNumber: lead?.contactNumber || '',
      alternateNumber: lead?.alternateNumber || '',
      email: lead?.email || '',
      gender: lead?.gender || 'MALE',
      age: lead?.age || '',
      height: lead?.height || '',
      weight: lead?.weight || '',
      actualProblem: lead?.actualProblem || '',
      existingTreatment: lead?.existingMedicalTreatment || '',
      maritalStatus: lead?.maritalStatus || '',
      // Address
      addressType: orderData?.addressType || lead?.addressType || 'City',
      latitude: orderData?.latitude ?? lead?.latitude ?? '',
      longitude: orderData?.longitude ?? lead?.longitude ?? '',
      houseNumber: orderData?.houseNumber || lead?.houseNumber || '',
      streetName: orderData?.streetName || lead?.streetName || '',
      colonyName: orderData?.colonyName || lead?.colonyName || '',
      landmark: orderData?.landmark ?? lead?.landmark ?? '',   // ✅ BUG FIX: || ki jagah ??
      areaPinCode: orderData?.areaPinCode || lead?.areaPinCode || '',
      postOffice: orderData?.cityTown || lead?.cityTown || lead?.postOffice || '',
      city: orderData?.cityTown || lead?.cityTown || '',            // ✅ BUG FIX: city populate kiya
      district: orderData?.district || lead?.district || '',
      state: orderData?.state || lead?.state || '',
      // Order
      orderType:
        orderData?.orderType
          ?.replace(/_/g, ' ')
          .replace(/\b\w/g, (l) => l.toUpperCase()) || '',
      remarks: orderData?.remarks || '',
      shippingMethod: orderData?.shippingMethod || '',
      paymentType: orderData?.paymentType || '',
      paymentMode: orderData?.paymentMode || '',
      prepaidAmount: orderData?.prepaidAmount || 0,
      discount: orderData?.discount || 0,
      shippingCharges: orderData?.shippingCharges || 0,
    });
    

    
  if (orderData?.orderItems) {
  const products = orderData.orderItems.map((item) => ({
    id: item.kitId || item.productId,   // ← FIX: kitId pehle check karo
    isKit: !!item.kitId,                // ← FIX: isKit set karo
    name: item.productName || 'Product',
    weight: item.weight || '',
    price: item.unitPrice,
    quantity: item.quantity,
    image: item.productImage || '📦',
  }));
  setSelectedProducts(products);
  // ✅ YEH ADD KARO
  console.log('RAW orderItems from DB:', JSON.stringify(orderData.orderItems, null, 2));
}
  } catch (error) {
    console.error('Error loading order data:', error);
    message.error('Failed to load order data');
    handleClose();
  } finally {
    setLoading(false);
  }
};

  // ─── handleChange ─────────────────────────────────────────────────────────────
const handleChange = (fieldName, value) => {
  console.log('handleChange:', fieldName, value);

  // Discount aur prepaidAmount cap logic
  if (fieldName === 'discount' || fieldName === 'prepaidAmount') {
    const subtotal = calculateSubtotal();
    const numValue = parseFloat(value) || 0;
    const otherField = fieldName === 'discount' ? 'prepaidAmount' : 'discount';
    const otherValue = parseFloat(formData[otherField]) || 0;
    const maxAllowed = Math.max(0, subtotal - otherValue);

    if (numValue > maxAllowed) {
      value = maxAllowed.toString();
    }
  }

  if (fieldName === 'paymentType') {
    let autoPaymentMode = '';
    if (value === 'COD') {
      autoPaymentMode = 'CASH';
    } else if (value === 'FULL_PAYMENT' || value === 'PART_PAYMENT') {
      autoPaymentMode = 'ONLINE';
    }
    setFormData(prev => ({ ...prev, [fieldName]: value, paymentMode: autoPaymentMode }));
  } else {
    setFormData(prev => ({ ...prev, [fieldName]: value }));
  }
};

  const handleSelectProduct = (product) => {
    const existingProduct = selectedProducts.find((p) => p.id === product.id);
    if (existingProduct) {
      setSelectedProducts(
        selectedProducts.map((p) =>
          p.id === product.id ? { ...p, quantity: p.quantity + 1 } : p
        )
      );
    } else {
      setSelectedProducts([...selectedProducts, { ...product, quantity: 1 }]);
    }
  };

  const updateQuantity = (productId, change) => {
    setSelectedProducts(
      selectedProducts
        .map((p) =>
          p.id === productId
            ? { ...p, quantity: Math.max(1, p.quantity + change) }
            : p
        )
        .filter((p) => p.quantity > 0)
    );
  };

  const removeProduct = (productId) => {
    setSelectedProducts(selectedProducts.filter((p) => p.id !== productId));
  };

  // ─── Totals ──────────────────────────────────────────────────────────────────
  const calculateSubtotal = () =>
    selectedProducts.reduce((total, p) => total + p.price * p.quantity, 0);

  const calculateGrossTotal = () =>
    selectedProducts.reduce((total, p) => total + (p.originalPrice || p.price) * p.quantity, 0);

  const calculateProductDiscount = () =>
    selectedProducts.reduce((total, p) => total + ((p.originalPrice || p.price) - p.price) * p.quantity, 0);

  const calculateTotalSaving = () =>
    calculateProductDiscount() + (parseFloat(formData.discount) || 0);

  const calculateGrandTotal = () => {
  const subtotal = calculateSubtotal();
  const discount = parseFloat(formData.discount) || 0;
  const shipping = parseFloat(formData.shippingCharges) || 0;
  return Math.max(0, subtotal - discount + shipping);
};

  const calculateBalance = () => {
  const total = calculateGrandTotal();
  const prepaid = parseFloat(formData.prepaidAmount) || 0;
  return Math.max(0, total - prepaid);
};

  // ─── Maps ────────────────────────────────────────────────────────────────────
  const orderTypeMap = {
    'Fresh Order': 'FRESH_ORDER',
    'Repeat Order': 'REPEAT_ORDER',
  };
  const shippingMethodMap = {
    'Free Shipping': 'FREE_SHIPPING',
    Standard: 'STANDARD',
    Express: 'EXPRESS',
    FREE_SHIPPING: 'FREE_SHIPPING',
    STANDARD: 'STANDARD',
    EXPRESS: 'EXPRESS',
  };
  const paymentModeMap = {
    ONLINE: 'ONLINE',
    UPI: 'UPI',
    CARD: 'CARD',
    CASH: 'COD',
    COD: 'COD',
    Online: 'ONLINE',
    Cash: 'COD',
  };

  // ─── Submit ──────────────────────────────────────────────────────────────────
  // ─── handleSubmit ─────────────────────────────────────────────────────────────
const handleSubmit = async () => {
  if (selectedProducts.length === 0) {
    message.warning('Please select at least one product');
    return;
  }

  const leadId = formData.leadId;
  if (!leadId) {
    message.error('Lead ID not found. Cannot update order.');
    return;
  }

  // Validate required fields
  const missingFields = [];
  if (!formData.name?.trim()) missingFields.push('Name');
  
  if (!formData.contactNumber?.trim()) {
    missingFields.push('Contact Number');
  } else if (!/^[0-9]{10}$/.test(formData.contactNumber.trim())) {
    message.error('Contact number must be exactly 10 digits');
    return;
  }
  
  if (formData.alternateNumber?.trim() && !/^[0-9]{10}$/.test(formData.alternateNumber.trim())) {
    message.error('Alternate number must be exactly 10 digits');
    return;
  }

  if (formData.email?.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email.trim())) {
    message.error('Invalid email format');
    return;
  }

  if (!formData.gender) missingFields.push('Gender');
  
  if (!formData.age?.toString().trim()) {
    missingFields.push('Age');
  } else {
    const ageVal = parseInt(formData.age);
    if (isNaN(ageVal) || ageVal < 1 || ageVal > 120) {
      message.error('Age must be between 1 and 120');
      return;
    }
  }

  if (formData.addressType === 'City') {
    if (!formData.city?.trim()) missingFields.push('City/Town');
  } else if (formData.addressType === 'Village') {
    if (!formData.colonyName?.trim()) missingFields.push('Village Name');
    if (!formData.streetName?.trim()) missingFields.push('Tehsil/Taluka/Block');
  } else {
    missingFields.push('Address Type');
  }

  if (!formData.areaPinCode?.trim()) {
    missingFields.push('Area Pin Code');
  } else if (!/^[0-9]{6}$/.test(formData.areaPinCode.trim())) {
    message.error('Pin code must be exactly 6 digits');
    return;
  }

  if (!formData.postOffice?.trim()) missingFields.push('Post Office');
  if (!formData.district?.trim()) missingFields.push('District');
  if (!formData.state?.trim()) missingFields.push('State');

  if (!formData.orderType?.trim()) missingFields.push('Order Type');
  if (!formData.shippingMethod?.trim()) missingFields.push('Shipping Method');
  if (!formData.paymentType?.trim()) missingFields.push('Payment Type');
  if (!formData.paymentMode?.trim()) missingFields.push('Payment Mode');

  if (missingFields.length > 0) {
    message.error(`Please fill in all required fields: ${missingFields.join(', ')}`);
    return;
  }

  try {
    setLoading(true);

    const paymentMode = paymentModeMap[formData.paymentMode] || 'COD';

    const orderData = {
      // Identity
      leadId,

      // Customer
      customerName: formData.name,
      contactNumber: formData.contactNumber,
      alternateNumber: formData.alternateNumber || null,
      email: formData.email || null,
      gender: formData.gender,
      age: parseInt(formData.age) || 0,
      height: formData.height || null,
      weight: formData.weight || null,
      maritalStatus: formData.maritalStatus || null,
      actualProblem: formData.actualProblem || null,
      existingMedicalTreatment: formData.existingTreatment || null,

      // Address
      addressType: formData.addressType || 'City',
      latitude: parseFloat(formData.latitude) || null,
      longitude: parseFloat(formData.longitude) || null,
      houseNumber: formData.houseNumber ?? null,
      streetName: formData.streetName ?? null,
      colonyName: formData.colonyName ?? null,
      landmark: formData.landmark ?? null,
      cityTown: formData.postOffice ?? null,
      city: formData.city ?? null,
      areaPinCode: formData.areaPinCode || null,
      district: formData.district ?? null,
      state: formData.state ?? null,

      // Order
      orderType: orderTypeMap[formData.orderType] || 'FRESH_ORDER',
      paymentMode,
      paymentType: formData.paymentType,
      shippingMethod: shippingMethodMap[formData.shippingMethod] || 'STANDARD',
      remarks: formData.remarks || '',
      discount: parseFloat(formData.discount) || 0,
      prepaidAmount: parseFloat(formData.prepaidAmount) || 0,
      shippingCharges: parseFloat(formData.shippingCharges) || 0,

      // Items
      orderItems: selectedProducts.map((product) => ({
        productId: product.isKit ? null : product.id,
        kitId: product.isKit ? product.id : null,
        isKit: product.isKit === true,
        quantity: product.quantity,
        unitPrice: product.price,
      })),
    };


    // ← YEH DO LINES ADD KARO YAHAN
    console.log('selectedProducts:', JSON.stringify(selectedProducts, null, 2));
    console.log('orderItems being sent:', JSON.stringify(orderData.orderItems, null, 2));

    // console.log('orderItems being sent:', orderData.orderItems);
    console.log('Updating order with data:', orderData);
    await ordersApi.updateOrder(id, orderData);
    console.log('✅ Order updated successfully');

    // ← FIX: fresh data load karo server se
    await loadOrderData();

    setShowSuccess(true);
    setTimeout(() => {
      handleClose();
    }, 2000);

  } catch (error) {
    console.error('❌ Error updating order:', error);
    message.error(`Failed to update order: ${error.message || 'Please try again.'}`);
  } finally {
    setLoading(false);
  }
};

  const handlePincodeChange = async (pincode) => {
    handleChange('areaPinCode', pincode);

    if (pincode.length === 6 && /^[0-9]{6}$/.test(pincode)) {
      setLoadingPincode(true);
      try {
        const response = await fetch(`https://api.postalpincode.in/pincode/${pincode}`);
        const data = await response.json();

        if (data && data.length > 0 && data[0].Status === 'Success') {
          const postOffices = data[0].PostOffice || [];
          const localities = postOffices.map(po => po.Name);
          setPostOfficeOptions(localities);

          if (postOffices.length > 0) {
            const firstPO = postOffices[0];
            const district = firstPO.District;
            const state = firstPO.State;
            const block = firstPO.Block !== "NA" ? firstPO.Block : district;

            setFormData(prev => ({
              ...prev,
              city: block || prev.city || '',        // ✅ setting the city/block input
              postOffice: '',          // ✅ reset - user dropdown se select karega
              district: district || prev.district,
              state: state || prev.state,
            }));
          }
        } else {
          console.log('No results found for pincode:', pincode);
          setPostOfficeOptions([]);
        }
      } catch (error) {
        console.error('Error fetching pincode data:', error);
        setPostOfficeOptions([]);
      } finally {
        setLoadingPincode(false);
      }
    } else {
      setPostOfficeOptions([]);
    }
  };
  // ─── Loading state ────────────────────────────────────────────────────────────
  if (loading && !formData.name) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader className="w-8 h-8 animate-spin text-teal-500" />
      </div>
    );
  }

  // ─── Render ──────────────────────────────────────────────────────────────────
  return (
    <div className={`min-h-screen ${isDark ? 'bg-[#0f172a]' : 'bg-[#E8F9F3]'}`}>
      <ProductSelectionModal
        isOpen={showProductModal}
        onClose={() => setShowProductModal(false)}
        onSelectProduct={handleSelectProduct}
      />

      {/* Success Toast */}
      {showSuccess && (
        <div className="fixed top-20 left-1/2 transform -translate-x-1/2 z-50">
          <div className="bg-white rounded-lg shadow-lg p-4 flex items-center space-x-3 border-2 border-teal-500">
            <div className="w-8 h-8 bg-teal-500 rounded-full flex items-center justify-center">
              <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <span className="font-medium text-gray-800">Order details updated successfully!</span>
          </div>
        </div>
      )}

      <div className="p-6">
        {/* Header */}
        <div className="flex items-center space-x-3 mb-6">
          <button onClick={() => navigate(-1)} className={`p-2 rounded-lg transition-colors ${isDark ? 'hover:bg-white/5' : 'hover:bg-white'}`}>
            <ArrowLeft className={`w-6 h-6 ${isDark ? 'text-white' : 'text-gray-700'}`} />
          </button>
          <h2 className={`text-2xl font-bold ${isDark ? 'text-white' : 'text-gray-800'}`}>Edit Order</h2>
        </div>

        <div className="grid grid-cols-3 gap-6">
          {/* ── Left Column ── */}
          <div className="col-span-2 space-y-6">

            {/* Customer Details */}
            <div className={`rounded-xl shadow-sm p-6 border ${isDark ? 'bg-[#111827] border-white/5' : 'bg-white border-gray-100'}`}>
              <h3 className={`text-lg font-bold mb-4 ${isDark ? 'text-white' : 'text-gray-800'}`}>Customer details</h3>
              <div className="grid grid-cols-3 gap-4">
                <div>
                  <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Name <span className="text-red-500">*</span></label>
                  <div className="relative">
                    <User className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-blue-500" />
                    <input type="text" value={formData.name} onChange={(e) => handleChange('name', e.target.value)}
                      className={`w-full pl-10 pr-4 py-2.5 border-2 rounded-lg focus:outline-none ${isDark ? 'bg-white/5 border-white/10 text-white focus:border-blue-500/50' : 'bg-gray-50 border-gray-300 focus:border-teal-500'}`} />
                  </div>
                </div>
                <div>
                  <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Contact number <span className="text-red-500">*</span></label>
                  <div className="relative">
                    <Phone className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-green-500" />
                    <input type="text" value={formData.contactNumber} onChange={(e) => handleChange('contactNumber', e.target.value)}
                      maxLength="10" className={`w-full pl-10 pr-4 py-2.5 border-2 rounded-lg focus:outline-none ${isDark ? 'bg-white/5 border-white/10 text-white focus:border-green-500/50' : 'bg-gray-50 border-gray-300 focus:border-teal-500'}`} />
                  </div>
                </div>
                <div>
                  <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Alternate number</label>
                  <div className="relative">
                    <Phone className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-orange-500" />
                    <input type="text" value={formData.alternateNumber} onChange={(e) => handleChange('alternateNumber', e.target.value)}
                      maxLength="10" className={`w-full pl-10 pr-4 py-2.5 border-2 rounded-lg focus:outline-none ${isDark ? 'bg-white/5 border-white/10 text-white focus:border-orange-500/50' : 'bg-gray-50 border-gray-300 focus:border-teal-500'}`} />
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-3 gap-4 mt-4">
                <div className="col-span-2">
                  <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Email</label>
                  <div className="relative">
                    <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-orange-500" />
                    <input type="email" value={formData.email} onChange={(e) => handleChange('email', e.target.value)}
                      className={`w-full pl-10 pr-4 py-2.5 border-2 rounded-lg focus:outline-none ${isDark ? 'bg-white/5 border-white/10 text-white focus:border-orange-500/50' : 'bg-gray-50 border-gray-300 focus:border-teal-500'}`} />
                  </div>
                </div>
                <div>
                  <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Gender <span className="text-red-500">*</span></label>
                  <div className="flex gap-2">
                    <label className={`flex-1 flex items-center justify-center space-x-2 px-4 py-2.5 border-2 rounded-lg cursor-pointer transition-all ${formData.gender === 'MALE' ? (isDark ? 'border-teal-500 bg-teal-500/10' : 'border-teal-500 bg-teal-50') : (isDark ? 'border-white/10 bg-white/5' : 'border-gray-300 bg-gray-50')}`}>
                      <input type="radio" name="gender" value="MALE" checked={formData.gender === 'MALE'} onChange={(e) => handleChange('gender', e.target.value)} className="text-teal-600" />
                      <span className={`text-sm ${isDark ? (formData.gender === 'MALE' ? 'text-teal-400 font-bold' : 'text-gray-400') : 'text-gray-700'}`}>Male</span>
                    </label>
                    <label className={`flex-1 flex items-center justify-center space-x-2 px-4 py-2.5 border-2 rounded-lg cursor-pointer transition-all ${formData.gender === 'FEMALE' ? (isDark ? 'border-teal-500 bg-teal-500/10' : 'border-teal-500 bg-teal-50') : (isDark ? 'border-white/10 bg-white/5' : 'border-gray-300 bg-gray-50')}`}>
                      <input type="radio" name="gender" value="FEMALE" checked={formData.gender === 'FEMALE'} onChange={(e) => handleChange('gender', e.target.value)} className="text-teal-600" />
                      <span className={`text-sm ${isDark ? (formData.gender === 'FEMALE' ? 'text-teal-400 font-bold' : 'text-gray-400') : 'text-gray-700'}`}>Female</span>
                    </label>
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-3 gap-4 mt-4">
                <div>
                  <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Age <span className="text-red-500">*</span></label>
                  <div className="relative">
                    <User className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
                    <input type="text" value={formData.age} onChange={(e) => handleChange('age', e.target.value)}
                      className={`w-full pl-10 pr-4 py-2.5 border-2 rounded-lg focus:outline-none ${isDark ? 'bg-white/5 border-white/10 text-white focus:border-teal-500/50' : 'bg-gray-50 border-gray-300 focus:border-teal-500'}`} />
                  </div>
                </div>
                <div className="col-span-2">
                  <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Height</label>
                  <div className="relative">
                    <Activity className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-cyan-500" />
                    <input type="text" value={formData.height} onChange={(e) => handleChange('height', e.target.value)}
                      className={`w-full pl-10 pr-4 py-2.5 border-2 rounded-lg focus:outline-none ${isDark ? 'bg-white/5 border-white/10 text-white focus:border-teal-500/50' : 'bg-gray-50 border-gray-300 focus:border-teal-500'}`} />
                  </div>
                </div>
              </div>
            </div>

            {/* Basic Details */}
            <div className={`rounded-xl shadow-sm p-6 border ${isDark ? 'bg-[#111827] border-white/5' : 'bg-white border-gray-100'}`}>
              <h3 className={`text-lg font-bold mb-4 ${isDark ? 'text-white' : 'text-gray-800'}`}>Basic details</h3>
              <div className="grid grid-cols-4 gap-4">
                <div>
                  <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Weight</label>
                  <div className="relative">
                    <Scale className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-red-500" />
                    <input type="text" value={formData.weight} onChange={(e) => handleChange('weight', e.target.value)}
                      className={`w-full pl-10 pr-4 py-2.5 border-2 rounded-lg focus:outline-none ${isDark ? 'bg-white/5 border-white/10 text-white focus:border-teal-500/50' : 'bg-gray-50 border-gray-300 focus:border-teal-500'}`} />
                  </div>
                </div>
                <div>
                  <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Actual Problem</label>
                  <div className="relative">
                    <Activity className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
                    <input type="text" value={formData.actualProblem} onChange={(e) => handleChange('actualProblem', e.target.value)}
                      className={`w-full pl-10 pr-4 py-2.5 border-2 rounded-lg focus:outline-none ${isDark ? 'bg-white/5 border-white/10 text-white focus:border-teal-500/50' : 'bg-gray-50 border-gray-300 focus:border-teal-500'}`} />
                  </div>
                </div>
                <div>
                  <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Existing medical Treatment</label>
                  <div className="relative">
                    <Pill className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-teal-500" />
                    <input type="text" value={formData.existingTreatment} onChange={(e) => handleChange('existingTreatment', e.target.value)}
                      className={`w-full pl-10 pr-4 py-2.5 border-2 rounded-lg focus:outline-none ${isDark ? 'bg-white/5 border-white/10 text-white focus:border-teal-500/50' : 'bg-gray-50 border-gray-300 focus:border-teal-500'}`} />
                  </div>
                </div>
                <div>
                  <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Marital Status</label>
                  <div className="relative">
                    <select value={formData.maritalStatus} onChange={(e) => handleChange('maritalStatus', e.target.value)}
                      className={`w-full pl-4 pr-10 py-0 h-[40px] border-2 rounded-lg focus:outline-none appearance-none text-sm ${isDark ? 'bg-white/5 border-white/10 text-white focus:border-teal-500/50' : 'bg-gray-50 border-gray-300 focus:border-teal-500'}`}>
                      <option value="">Please select</option>
                      {maritalStatuses.map((status) => (
                        <option key={status} value={status}>{status}</option>
                      ))}
                    </select>
                    <ChevronDown className={`absolute right-3 top-1/2 transform -translate-y-1/2 w-4 h-4 pointer-events-none ${isDark ? 'text-gray-500' : 'text-gray-400'}`} />
                  </div>
                </div>
              </div>
            </div>

            {/* ── Address Section ── */}
            <div className={`rounded-xl shadow-sm p-6 border ${isDark ? 'bg-[#111827] border-white/5' : 'bg-white border-gray-100'}`}>
              <h3 className={`text-lg font-bold mb-4 ${isDark ? 'text-white' : 'text-gray-800'}`}>Address</h3>

              {/* Map + Lat/Long */}
              <div className="mb-4 grid grid-cols-1 lg:grid-cols-3 gap-4">
                {/* Map Placeholder */}
                <div className={`lg:col-span-2 rounded-lg h-[180px] flex items-center justify-center border-2 ${isDark ? 'bg-white/5 border-white/10' : 'bg-gray-100 border-gray-200'}`}>
                  <div className="text-center text-gray-500">
                    <MapPin className="w-10 h-10 mx-auto mb-2 opacity-50" />
                    <p className="text-sm">Map View</p>
                  </div>
                </div>

                {/* Latitude & Longitude */}
                <div className="space-y-3">
                  <div>
                    <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Latitude</label>
                    <div className="relative">
                      <MapPin className="absolute left-2 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
                      <input
                        type="text"
                        placeholder="28.613241"
                        value={formData.latitude}
                        onChange={(e) => handleChange('latitude', e.target.value)}
                        className={`w-full pl-8 pr-3 py-2 h-[40px] border-2 rounded-lg focus:outline-none text-sm ${isDark ? 'bg-white/5 border-white/10 text-white focus:border-teal-500/50' : 'bg-gray-50 border-gray-300 focus:border-teal-500'}`}
                      />
                    </div>
                  </div>
                  <div>
                    <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Longitude</label>
                    <div className="relative">
                      <MapPin className="absolute left-2 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
                      <input
                        type="text"
                        placeholder="77.381349"
                        value={formData.longitude}
                        onChange={(e) => handleChange('longitude', e.target.value)}
                        className={`w-full pl-8 pr-3 py-2 h-[40px] border-2 rounded-lg focus:outline-none text-sm ${isDark ? 'bg-white/5 border-white/10 text-white focus:border-teal-500/50' : 'bg-gray-50 border-gray-300 focus:border-teal-500'}`}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Address Type */}
              <div className="mb-4">
                <label className={`text-sm mb-2 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Select address type <span className="text-red-500">*</span></label>
                <div className="flex gap-4">
                  {['City', 'Village'].map((type) => (
                    <label
                      key={type}
                      className={`flex items-center space-x-2 px-6 py-2.5 h-[40px] border-2 rounded-lg cursor-pointer transition-all ${formData.addressType === type
                        ? (isDark ? 'border-teal-500 bg-teal-500/10' : 'border-teal-500 bg-teal-50')
                        : (isDark ? 'border-white/10 bg-white/5' : 'border-gray-300 bg-gray-50')
                        }`}
                    >
                      <input
                        type="radio"
                        name="addressType"
                        value={type}
                        checked={formData.addressType === type}
                        onChange={() => {
                          setFormData(prev => ({
                            ...prev,
                            addressType: type,
                            postOffice: '',
                            houseNumber: '',
                            streetName: '',
                            colonyName: '',
                            landmark: '',
                          }));
                          setPostOfficeOptions([]);
                        }}
                        className="text-teal-600"
                      />
                      <span className={`text-sm font-medium ${isDark ? (formData.addressType === type ? 'text-teal-400' : 'text-gray-400') : 'text-gray-700'}`}>{type}</span>
                    </label>
                  ))}
                </div>
              </div>

              {/* ═══════════════ CITY FIELDS ═══════════════ */}
              {formData.addressType === 'City' && (
                <div className="space-y-4">
                  {/* Row 1 */}
                  <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
                    {/* House Number */}
                    <div>
                      <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>House /Flat /Building No.</label>
                      <div className="relative">
                        <Home className="absolute left-2 top-1/2 transform -translate-y-1/2 w-4 h-4 text-purple-500" />
                        <input type="text" placeholder="45" value={formData.houseNumber}
                          onChange={(e) => handleChange('houseNumber', e.target.value)}
                          className={`w-full pl-8 pr-3 py-2.5 h-[40px] border-2 rounded-lg focus:outline-none text-sm ${isDark ? 'bg-white/5 border-white/10 text-white focus:border-teal-500/50' : 'bg-gray-50 border-gray-300 focus:border-teal-500'}`} />
                      </div>
                    </div>
                    {/* Street */}
                    <div>
                      <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Street No./Road Name</label>
                      <div className="relative">
                        <MapPin className="absolute left-2 top-1/2 transform -translate-y-1/2 w-4 h-4 text-orange-500" />
                        <input type="text" placeholder="MG Road" value={formData.streetName}
                          onChange={(e) => handleChange('streetName', e.target.value)}
                          className={`w-full pl-8 pr-3 py-2.5 h-[40px] border-2 rounded-lg focus:outline-none text-sm ${isDark ? 'bg-white/5 border-white/10 text-white focus:border-teal-500/50' : 'bg-gray-50 border-gray-300 focus:border-teal-500'}`} />
                      </div>
                    </div>
                    {/* Colony */}
                    <div>
                      <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Colony/Society Name</label>
                      <div className="relative">
                        <MapPin className="absolute left-2 top-1/2 transform -translate-y-1/2 w-4 h-4 text-blue-500" />
                        <input type="text" placeholder="Green Park" value={formData.colonyName}
                          onChange={(e) => handleChange('colonyName', e.target.value)}
                          className={`w-full pl-8 pr-3 py-2.5 h-[40px] border-2 rounded-lg focus:outline-none text-sm ${isDark ? 'bg-white/5 border-white/10 text-white focus:border-teal-500/50' : 'bg-gray-50 border-gray-300 focus:border-teal-500'}`} />
                      </div>
                    </div>
                    {/* Landmark */}
                    <div>
                      <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Landmark</label>
                      <div className="relative">
                        <MapPin className="absolute left-2 top-1/2 transform -translate-y-1/2 w-4 h-4 text-orange-400" />
                        <input type="text" placeholder="Near Metro" value={formData.landmark}
                          onChange={(e) => handleChange('landmark', e.target.value)}
                          className={`w-full pl-8 pr-3 py-2.5 h-[40px] border-2 rounded-lg focus:outline-none text-sm ${isDark ? 'bg-white/5 border-white/10 text-white focus:border-teal-500/50' : 'bg-gray-50 border-gray-300 focus:border-teal-500'}`} />
                      </div>
                    </div>
                  </div>

                  {/* Row 2 */}
                  <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
                    {/* Pin Code */}
                    <div>
                      <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Area pin code <span className="text-red-500">*</span></label>
                      <div className="relative">
                        <MapPin className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-orange-500" />
                        <input type="text" value={formData.areaPinCode}
                          onChange={(e) => handlePincodeChange(e.target.value.replace(/\D/g, '').slice(0, 6))}
                          placeholder="201014" maxLength="6"
                          className={`w-full pl-9 pr-8 py-2.5 h-[40px] border-2 rounded-lg focus:outline-none text-sm ${isDark ? 'bg-white/5 border-white/10 text-white focus:border-teal-500/50' : 'bg-gray-50 border-gray-300 focus:border-teal-500'}`} />
                        {loadingPincode && <Loader className="absolute right-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-teal-500 animate-spin" />}
                      </div>
                    </div>
                    {/* City/Town Dropdown */}
                    <div>
                      <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>City/Town <span className="text-red-500">*</span></label>
                      <div className="relative">
                        <MapPin className="absolute left-2 top-1/2 transform -translate-y-1/2 w-4 h-4 text-green-500" />
                        <input type="text" placeholder="Please enter" value={formData.city || ''}
                          onChange={(e) => handleChange('city', e.target.value)}
                          className={`w-full pl-8 pr-3 h-[40px] border-2 rounded-lg focus:outline-none text-sm ${isDark ? 'bg-white/5 border-white/10 text-white focus:border-teal-500/50' : 'bg-gray-50 border-gray-300 focus:border-teal-500'}`} />
                      </div>
                    </div>
                    {/* ✅ Post Office - dropdown from postcode_localities */}
                    <div>
                      <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Post Office <span className="text-red-500">*</span></label>
                      <div className="relative">
                        <MapPin className="absolute left-2 top-1/2 transform -translate-y-1/2 w-4 h-4 text-blue-500" />
                        {postOfficeOptions.length > 0 ? (
                          <select value={formData.postOffice}
                            onChange={(e) => handleChange('postOffice', e.target.value)}
                            className={`w-full pl-8 pr-8 h-[40px] border-2 rounded-lg focus:outline-none appearance-none text-sm ${isDark ? 'bg-[#1e293b] border-white/10 text-white focus:border-teal-500/50' : 'bg-gray-50 border-gray-300 focus:border-teal-500'}`}>
                            <option value="">Please select</option>
                            {postOfficeOptions.map((loc) => (
                              <option key={loc} value={loc}>{loc}</option>
                            ))}
                          </select>
                        ) : (
                          <input type="text" placeholder="Enter pincode first" value={formData.postOffice}
                            onChange={(e) => handleChange('postOffice', e.target.value)}
                            className={`w-full pl-8 pr-3 h-[40px] border-2 rounded-lg focus:outline-none text-sm ${isDark ? 'bg-white/5 border-white/10 text-white focus:border-teal-500/50' : 'bg-gray-50 border-gray-300 focus:border-teal-500'}`} />
                        )}
                        <ChevronDown className={`absolute right-2 top-1/2 transform -translate-y-1/2 w-4 h-4 pointer-events-none ${isDark ? 'text-gray-500' : 'text-gray-400'}`} />
                      </div>
                    </div>
                    {/* District */}
                    <div>
                      <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>District <span className="text-red-500">*</span></label>
                      <div className="relative">
                        <MapPin className="absolute left-2 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-500" />
                        <input type="text" placeholder="Gautam Budh Nagar" value={formData.district}
                          onChange={(e) => handleChange('district', e.target.value)}
                          className={`w-full pl-8 pr-3 py-2.5 h-[40px] border-2 rounded-lg focus:outline-none text-sm ${isDark ? 'bg-white/5 border-white/10 text-white focus:border-teal-500/50' : 'bg-gray-50 border-gray-300 focus:border-teal-500'}`} />
                      </div>
                    </div>
                    {/* State */}
                    <div>
                      <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>State <span className="text-red-500">*</span></label>
                      <div className="relative">
                        <MapPin className="absolute left-2 top-1/2 transform -translate-y-1/2 w-4 h-4 text-red-500" />
                        <input type="text" placeholder="Uttar Pradesh" value={formData.state}
                          onChange={(e) => handleChange('state', e.target.value)}
                          className={`w-full pl-8 pr-3 py-2.5 h-[40px] border-2 rounded-lg focus:outline-none text-sm ${isDark ? 'bg-white/5 border-white/10 text-white focus:border-teal-500/50' : 'bg-gray-50 border-gray-300 focus:border-teal-500'}`} />
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* ═══════════════ VILLAGE FIELDS ═══════════════ */}
              {formData.addressType === 'Village' && (
                <div className="space-y-4">
                  {/* Row 1 */}
                  <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
                    {/* Ward/House Number */}
                    <div>
                      <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Ward Number/House Number <span className="text-red-500">*</span></label>
                      <div className="relative">
                        <Home className="absolute left-2 top-1/2 transform -translate-y-1/2 w-4 h-4 text-purple-500" />
                        <input type="text" placeholder="45" value={formData.houseNumber}
                          onChange={(e) => handleChange('houseNumber', e.target.value)}
                          className={`w-full pl-8 pr-3 py-2.5 h-[40px] border-2 rounded-lg focus:outline-none text-sm ${isDark ? 'bg-white/5 border-white/10 text-white focus:border-teal-500/50' : 'bg-gray-50 border-gray-300 focus:border-teal-500'}`} />
                      </div>
                    </div>
                    {/* Village Name */}
                    <div>
                      <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Village Name <span className="text-red-500">*</span></label>
                      <div className="relative">
                        <Home className="absolute left-2 top-1/2 transform -translate-y-1/2 w-4 h-4 text-orange-500" />
                        <input type="text" placeholder="Please enter" value={formData.colonyName}
                          onChange={(e) => handleChange('colonyName', e.target.value)}
                          className={`w-full pl-8 pr-3 py-2.5 h-[40px] border-2 rounded-lg focus:outline-none text-sm ${isDark ? 'bg-white/5 border-white/10 text-white focus:border-teal-500/50' : 'bg-gray-50 border-gray-300 focus:border-teal-500'}`} />
                      </div>
                    </div>
                    {/* Landmark */}
                    <div>
                      <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Landmark</label>
                      <div className="relative">
                        <MapPin className="absolute left-2 top-1/2 transform -translate-y-1/2 w-4 h-4 text-orange-400" />
                        <input type="text" placeholder="Please enter" value={formData.landmark}
                          onChange={(e) => handleChange('landmark', e.target.value)}
                          className={`w-full pl-8 pr-3 py-2.5 h-[40px] border-2 rounded-lg focus:outline-none text-sm ${isDark ? 'bg-white/5 border-white/10 text-white focus:border-teal-500/50' : 'bg-gray-50 border-gray-300 focus:border-teal-500'}`} />
                      </div>
                    </div>
                    {/* Pin Code */}
                    <div>
                      <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Area pin code <span className="text-red-500">*</span></label>
                      <div className="relative">
                        <MapPin className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-orange-500" />
                        <input type="text" value={formData.areaPinCode}
                          onChange={(e) => handlePincodeChange(e.target.value.replace(/\D/g, '').slice(0, 6))}
                          placeholder="201014" maxLength="6"
                          className={`w-full pl-9 pr-8 py-2.5 h-[40px] border-2 rounded-lg focus:outline-none text-sm ${isDark ? 'bg-white/5 border-white/10 text-white focus:border-teal-500/50' : 'bg-gray-50 border-gray-300 focus:border-teal-500'}`} />
                        {loadingPincode && <Loader className="absolute right-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-teal-500 animate-spin" />}
                      </div>
                    </div>
                  </div>

                  {/* Row 2 */}
                  <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
                    {/* Post Office Dropdown */}
                    <div>
                      <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Post Office <span className="text-red-500">*</span></label>
                      <div className="relative">
                        <MapPin className="absolute left-2 top-1/2 transform -translate-y-1/2 w-4 h-4 text-green-500" />
                        {postOfficeOptions.length > 0 ? (
                          <select value={formData.postOffice}
                            onChange={(e) => handleChange('postOffice', e.target.value)}
                            className={`w-full pl-8 pr-8 h-[40px] border-2 rounded-lg focus:outline-none appearance-none text-sm ${isDark ? 'bg-[#1e293b] border-white/10 text-white focus:border-teal-500/50' : 'bg-gray-50 border-gray-300 focus:border-teal-500'}`}>
                            <option value="">Please select</option>
                            {postOfficeOptions.map((loc) => (
                              <option key={loc} value={loc}>{loc}</option>
                            ))}
                          </select>
                        ) : (
                          <input type="text" placeholder="Enter pincode first" value={formData.postOffice}
                            onChange={(e) => handleChange('postOffice', e.target.value)}
                            className={`w-full pl-8 pr-3 h-[40px] border-2 rounded-lg focus:outline-none text-sm ${isDark ? 'bg-white/5 border-white/10 text-white focus:border-teal-500/50' : 'bg-gray-50 border-gray-300 focus:border-teal-500'}`} />
                        )}
                        <ChevronDown className={`absolute right-2 top-1/2 transform -translate-y-1/2 w-4 h-4 pointer-events-none ${isDark ? 'text-gray-500' : 'text-gray-400'}`} />
                      </div>
                    </div>
                    {/* Tehsil */}
                    <div>
                      <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Tehsil/Taluka/Block <span className="text-red-500">*</span></label>
                      <div className="relative">
                        <MapPin className="absolute left-2 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-500" />
                        <input type="text" placeholder="Please enter" value={formData.streetName}
                          onChange={(e) => handleChange('streetName', e.target.value)}
                          className={`w-full pl-8 pr-3 py-2.5 h-[40px] border-2 rounded-lg focus:outline-none text-sm ${isDark ? 'bg-white/5 border-white/10 text-white focus:border-teal-500/50' : 'bg-gray-50 border-gray-300 focus:border-teal-500'}`} />
                      </div>
                    </div>
                    {/* District */}
                    <div>
                      <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>District <span className="text-red-500">*</span></label>
                      <div className="relative">
                        <MapPin className="absolute left-2 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-500" />
                        <input type="text" placeholder="Please enter" value={formData.district}
                          onChange={(e) => handleChange('district', e.target.value)}
                          className={`w-full pl-8 pr-3 py-2.5 h-[40px] border-2 rounded-lg focus:outline-none text-sm ${isDark ? 'bg-white/5 border-white/10 text-white focus:border-teal-500/50' : 'bg-gray-50 border-gray-300 focus:border-teal-500'}`} />
                      </div>
                    </div>
                    {/* State */}
                    <div>
                      <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>State <span className="text-red-500">*</span></label>
                      <div className="relative">
                        <MapPin className="absolute left-2 top-1/2 transform -translate-y-1/2 w-4 h-4 text-red-500" />
                        <input type="text" placeholder="Please enter" value={formData.state}
                          onChange={(e) => handleChange('state', e.target.value)}
                          className={`w-full pl-8 pr-3 py-2.5 h-[40px] border-2 rounded-lg focus:outline-none text-sm ${isDark ? 'bg-white/5 border-white/10 text-white focus:border-teal-500/50' : 'bg-gray-50 border-gray-300 focus:border-teal-500'}`} />
                      </div>
                    </div>
                  </div>
                </div>
              )}

            </div>

            {/* Order Details */}
            <div className={`rounded-xl shadow-sm p-6 border ${isDark ? 'bg-[#111827] border-white/5' : 'bg-white border-gray-100'}`}>
              <h3 className={`text-lg font-bold mb-4 ${isDark ? 'text-white' : 'text-gray-800'}`}>Order details</h3>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Order type <span className="text-red-500">*</span></label>
                  <div className="relative">
                    <Package className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-blue-500" />
                    <select value={formData.orderType} onChange={(e) => handleChange('orderType', e.target.value)}
                      className={`w-full pl-10 pr-10 py-2.5 border-2 rounded-lg focus:outline-none appearance-none ${isDark ? 'bg-white/5 border-white/10 text-white focus:border-teal-500/50' : 'bg-gray-50 border-gray-300 focus:border-teal-500'}`}>
                      <option value="">Please select</option>
                      <option value="Fresh Order">Fresh Order</option>
                      <option value="Repeat Order">Repeat Order</option>
                    </select>
                    <ChevronDown className={`absolute right-3 top-1/2 transform -translate-y-1/2 w-4 h-4 pointer-events-none ${isDark ? 'text-gray-500' : 'text-gray-400'}`} />
                  </div>
                </div>
                <div>
                  <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Remarks</label>
                  <div className="relative">
                    <FileText className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
                    <input type="text" value={formData.remarks} onChange={(e) => handleChange('remarks', e.target.value)}
                      className={`w-full pl-10 pr-4 py-2.5 border-2 rounded-lg focus:outline-none ${isDark ? 'bg-white/5 border-white/10 text-white focus:border-teal-500/50' : 'bg-gray-50 border-gray-300 focus:border-teal-500'}`} />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* ── Right Column ── */}
          <div className="space-y-6">
            {/* Products */}
            {selectedProducts.length > 0 ? (
              <div className="space-y-4">
                {selectedProducts.map((product, index) => (
                  <div key={`${product.isKit ? 'kit' : 'prod'}_${product.id}_${index}`} className={`rounded-xl shadow-sm p-4 border ${isDark ? 'bg-[#111827] border-white/5' : 'bg-white border-gray-100'}`}>
                    <div className="flex items-center space-x-3 mb-4">
                      <div className={`w-14 h-14 rounded-lg flex items-center justify-center text-2xl overflow-hidden ${isDark ? 'bg-white/5' : 'bg-teal-50'}`}>
                        {product.image && typeof product.image === 'string' && product.image.startsWith('http') ? (
                          <img src={product.image} alt={product.name} className="w-full h-full object-cover" />
                        ) : (
                          <span className="text-2xl">{product.image || '📦'}</span>
                        )}
                      </div>
                      <div className="flex-1">
                        <h4 className={`font-semibold ${isDark ? 'text-white' : 'text-gray-900'}`}>{product.name}</h4>
                        {product.weight && <p className="text-xs text-gray-500">{product.weight}</p>}
                        <p className={`text-sm mt-1 ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>₹{product.price}</p>
                      </div>
                      <button onClick={() => removeProduct(product.id)} className={`p-2 rounded-lg transition-colors ${isDark ? 'hover:bg-red-500/10' : 'hover:bg-red-50'}`}>
                        <Trash2 className="w-4 h-4 text-red-500" />
                      </button>
                    </div>
                    <div className="flex items-center justify-between">
                      <div className="flex items-center space-x-3">
                        <button onClick={() => updateQuantity(product.id, -1)} className={`w-8 h-8 flex items-center justify-center rounded transition-colors ${isDark ? 'bg-white/5 hover:bg-white/10 text-white' : 'bg-gray-100 hover:bg-gray-200'}`}>
                          <Minus className="w-4 h-4" />
                        </button>
                        <span className={`font-semibold ${isDark ? 'text-white' : 'text-gray-900'}`}>{product.quantity}</span>
                        <button onClick={() => updateQuantity(product.id, 1)} className={`w-8 h-8 flex items-center justify-center rounded transition-colors ${isDark ? 'bg-white/5 hover:bg-white/10 text-white' : 'bg-gray-100 hover:bg-gray-200'}`}>
                          <Plus className="w-4 h-4" />
                        </button>
                      </div>
                      <div className="text-right">
                        <p className="text-xs text-gray-500">Total</p>
                        <p className={`text-lg font-bold ${isDark ? 'text-white' : 'text-gray-900'}`}>₹{product.price * product.quantity}</p>
                      </div>
                    </div>
                  </div>
                ))}
                <button onClick={() => setShowProductModal(true)}
                  className={`w-full py-3 border-2 border-dashed rounded-lg transition-all flex items-center justify-center space-x-2 ${isDark ? 'border-teal-500/30 text-teal-500 hover:bg-teal-500/10' : 'border-teal-300 text-teal-600 hover:bg-teal-50'}`}>
                  <Plus className="w-4 h-4" />
                  <span className="text-sm font-medium">Add item</span>
                </button>
              </div>
            ) : (
              <div className={`rounded-xl shadow-sm p-8 text-center border ${isDark ? 'bg-[#111827] border-white/5' : 'bg-white border-gray-100'}`}>
                <Package className={`w-12 h-12 mx-auto mb-3 ${isDark ? 'text-gray-700' : 'text-gray-300'}`} />
                <p className={`mb-4 ${isDark ? 'text-gray-500' : 'text-gray-500'}`}>No products added</p>
                <button onClick={() => setShowProductModal(true)}
                  className="px-6 py-2 bg-teal-500 text-white rounded-lg hover:bg-teal-600 transition-colors flex items-center justify-center space-x-2 mx-auto shadow-lg shadow-teal-500/20">
                  <Plus className="w-4 h-4" />
                  <span className="text-sm font-medium">Add Product</span>
                </button>
              </div>
            )}

            {/* Form Inputs */}
            <div className={`rounded-xl shadow-sm p-4 space-y-4 border ${isDark ? 'bg-[#111827] border-white/5' : 'bg-white border-gray-100'}`}>
              <div>
                <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Shipping Method</label>
                <div className="relative">
                  <select value={formData.shippingMethod} onChange={(e) => handleChange('shippingMethod', e.target.value)}
                    className={`w-full px-4 py-2.5 border-2 rounded-lg focus:outline-none appearance-none text-sm ${isDark ? 'bg-white/5 border-white/10 text-white focus:border-teal-500/50' : 'bg-gray-50 border-gray-300 focus:border-teal-500'}`}>
                    <option value="">Please select</option>
                    <option value="FREE_SHIPPING">Free Shipping</option>
                    <option value="STANDARD">Standard Shipping</option>
                    <option value="EXPRESS">Express Shipping</option>
                  </select>
                  <ChevronDown className={`absolute right-3 top-1/2 transform -translate-y-1/2 w-4 h-4 pointer-events-none ${isDark ? 'text-gray-500' : 'text-gray-400'}`} />
                </div>
              </div>
              <div>
                <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Payment type</label>
                <div className="relative">
                  <select value={formData.paymentType} onChange={(e) => handleChange('paymentType', e.target.value)}
                    className={`w-full px-4 py-2.5 border-2 rounded-lg focus:outline-none appearance-none text-sm ${isDark ? 'bg-white/5 border-white/10 text-white focus:border-teal-500/50' : 'bg-gray-50 border-gray-300 focus:border-teal-500'}`}>
                    <option value="">Please select</option>
                    <option value="PART_PAYMENT">Part Payment</option>
                    <option value="FULL_PAYMENT">Full Payment</option>
                    <option value="COD">COD</option>
                  </select>
                  <ChevronDown className={`absolute right-3 top-1/2 transform -translate-y-1/2 w-4 h-4 pointer-events-none ${isDark ? 'text-gray-500' : 'text-gray-400'}`} />
                </div>
              </div>
              <div>
                <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Payment Mode</label>
                <div className="relative">
                  <select value={formData.paymentMode} onChange={(e) => handleChange('paymentMode', e.target.value)}
                    className={`w-full px-4 py-2.5 border-2 rounded-lg focus:outline-none appearance-none text-sm ${isDark ? 'bg-white/5 border-white/10 text-white focus:border-teal-500/50' : 'bg-gray-50 border-gray-300 focus:border-teal-500'}`}>
                    <option value="">Please select</option>
                    {(!formData.paymentType || formData.paymentType === 'FULL_PAYMENT' || formData.paymentType === 'PART_PAYMENT') && (
                      <>
                        <option value="ONLINE">Online</option>
                        <option value="UPI">UPI</option>
                        <option value="CARD">Card</option>
                      </>
                    )}
                    {formData.paymentType === 'COD' && (
                      <>
                        <option value="CASH">Cash</option>
                      </>
                    )}
                  </select>
                  <ChevronDown className={`absolute right-3 top-1/2 transform -translate-y-1/2 w-4 h-4 pointer-events-none ${isDark ? 'text-gray-500' : 'text-gray-400'}`} />
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Prepaid amount</label>
                  <div className="relative">
                    <span className={`absolute left-3 top-1/2 transform -translate-y-1/2 ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>₹</span>
                    <input type="number" value={formData.prepaidAmount} onChange={(e) => handleChange('prepaidAmount', e.target.value)}
                      disabled={formData.paymentType !== 'PART_PAYMENT'}
                      className={`w-full pl-8 pr-4 py-2.5 border-2 rounded-lg focus:outline-none text-sm ${formData.paymentType !== 'PART_PAYMENT' ? (isDark ? 'bg-white/5 border-white/5 text-gray-500 cursor-not-allowed' : 'bg-gray-100 border-gray-200 cursor-not-allowed text-gray-400') : (isDark ? 'bg-white/5 border-white/10 text-white focus:border-teal-500/50' : 'bg-white border-gray-300 focus:border-teal-500')}`} />
                  </div>
                </div>
                <div>
                  <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Discount</label>
                  <div className="relative">
                    <span className={`absolute left-3 top-1/2 transform -translate-y-1/2 ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>₹</span>
                    <input type="number" value={formData.discount} onChange={(e) => handleChange('discount', e.target.value)}
                      className={`w-full pl-8 pr-4 py-2.5 border-2 rounded-lg focus:outline-none text-sm ${isDark ? 'bg-white/5 border-white/10 text-white focus:border-teal-500/50' : 'bg-gray-50 border-gray-300 focus:border-teal-500'}`} />
                  </div>
                </div>
              </div>

              <div>
                <label className={`text-sm mb-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Order status</label>
                <div className="relative">
                  <select className={`w-full px-4 py-2.5 border-2 rounded-lg focus:outline-none appearance-none text-sm ${isDark ? 'bg-white/5 border-white/10 text-white focus:border-teal-500/50' : 'bg-gray-50 border-gray-300 focus:border-teal-500'}`}>
                    <option>Approval pending</option>
                  </select>
                  <ChevronDown className={`absolute right-3 top-1/2 transform -translate-y-1/2 w-4 h-4 pointer-events-none ${isDark ? 'text-gray-500' : 'text-gray-400'}`} />
                </div>
              </div>
            </div>

            {/* Summary */}
            <div className={`rounded-xl shadow-sm p-4 border ${isDark ? 'bg-[#111827] border-white/5' : 'bg-white border-gray-100'}`}>
              <h3 className={`text-lg font-bold mb-4 ${isDark ? 'text-white' : 'text-gray-800'}`}>Summary</h3>
              <div className="space-y-3">
                <div className="flex justify-between text-sm">
                  <span className={isDark ? 'text-gray-400' : 'text-gray-600'}>Sub total (Gross)</span>
                  <span className={`font-semibold ${isDark ? 'text-white' : 'text-gray-900'}`}>₹{calculateGrossTotal()}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <span className={isDark ? 'text-gray-400' : 'text-gray-600'}>Total Discounts</span>
                  <span className="font-semibold text-green-600">₹{calculateTotalSaving()}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <span className={isDark ? 'text-gray-400' : 'text-gray-600'}>Net Total</span>
                  <span className={`font-semibold ${isDark ? 'text-white' : 'text-gray-900'}`}>₹{calculateGrandTotal()}</span>
                </div>
                <div className={`flex justify-between text-sm pt-2 border-t ${isDark ? 'border-white/5' : 'border-gray-100'}`}>
                  <span className={isDark ? 'text-gray-400' : 'text-gray-600'}>Prepaid Amount</span>
                  <span className="font-semibold text-green-600">₹{formData.prepaidAmount || 0}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <span className={isDark ? 'text-gray-400' : 'text-gray-600'}>Shipping Charges</span>
                  <span className="font-semibold text-emerald-600">Free</span>
                </div>
              </div>
              <div className="mt-4">
                <div className="text-white px-4 py-3 rounded-lg flex justify-between items-center shadow-lg" style={{ backgroundColor: currentTheme.color }}>
                  <span className="text-sm font-medium">Balance Amount:</span>
                  <span className="text-xl font-bold">₹{calculateBalance()}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Update Button */}
        <div className="fixed bottom-6 right-6 z-50">
          <button onClick={handleSubmit} disabled={loading}
            className="px-10 py-4 text-white rounded-2xl font-black uppercase tracking-widest text-xs transition-all flex items-center space-x-3 hover:-translate-y-1 active:translate-y-0.5 disabled:opacity-50 disabled:cursor-not-allowed shadow-xl"
            style={{ backgroundColor: currentTheme.color, boxShadow: `0 10px 40px -10px ${currentTheme.color}80` }}>
            {loading ? (
              <>
                <Loader className="w-5 h-5 animate-spin" />
                <span>Processing...</span>
              </>
            ) : (
              <>
                <Check className="w-5 h-5" strokeWidth={3} />
                <span>Update Order</span>
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

export default EditOrder;